import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import "leaflet/dist/leaflet.css";
import "@/index.css";
import "@/i18n/index";
import "@/lib/breadcrumbs"; // installs console/nav/click auto-capture
import { installGlobalErrorReporter } from "@/lib/errorReporter";
import { ensureServiceWorker } from "@/lib/push";
import App from "@/App";

// Sentry init — captura excepciones del browser con stack traces ricos +
// session replay (graba lo que vio el user antes del error). Complementa
// `errorReporter.js` (que sigue mandando 5xx + uncaught al backend admin_alerts
// para audit trail). Si VITE_SENTRY_DSN no está set, no-op silencioso.
const sentryDsn = import.meta.env.VITE_SENTRY_DSN;
if (sentryDsn && import.meta.env.PROD) {
  Sentry.init({
    dsn: sentryDsn,
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_APP_VERSION,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        // Masking automático de inputs/textarea — protección PII por default.
        maskAllText: false,
        maskAllInputs: true,
        blockAllMedia: false,
      }),
    ],
    // 10% de navegaciones reportan performance traces — conservador para
    // mantenerse dentro del tier gratis (10k traces/mes).
    tracesSampleRate: 0.1,
    // 10% de sesiones normales se graban; 100% de sesiones con error.
    // Tier gratis = 50 replays/mes, suficiente para los casos donde algo
    // truena (el caso interesante para debug).
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

installGlobalErrorReporter();
ensureServiceWorker();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
